export const ActionTypes = {
  SET_IS_VISIBLE: 'SET_IS_VISIBLE',
  SET_IS_VISIBLE_CHARTS: 'SET_IS_VISIBLE_CHARTS',
};
